import { TuiButtonModule } from '@taiga-ui/core';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgClass } from '@angular/common';

import { IconComponent } from '../icon';

@Component({
  selector: 'iss-expand-icon',
  template: `
    <button
      tuiIconButton
      appearance="iss-icon-button"
      size="xs"
      type="button"
      (click)="toggle()"
    >
      <iss-icon
        class="iss-expand-icon"
        [ngClass]="{ 'iss-expand-icon--expanded': expanded }"
        name="angle-right"
      />
    </button>
    `,
  styleUrls: [ './expand-icon.component.scss' ],
  standalone: true,
  imports: [ IconComponent, NgClass, TuiButtonModule ],
})
export class ExpandIconComponent {
  @Input() public expanded = false;
  @Output() public readonly expandedChange = new EventEmitter<boolean>();

  public toggle(): void {
    this.expanded = !this.expanded;
    this.expandedChange.emit(this.expanded);
  }
}
